export const SERVER_ERROR_MESSAGE =
  'Ops! Parece que algo deu errado. Estamos trabalhando para resolver o problema. Por favor, tente novamente em alguns minutos.';

export const UNKNOWN_ERROR =
  'Ops! Ocorreu um erro inesperado. Por favor, tente novamente em alguns minutos.';

export const COMPANY_ERROR_STATUSES = [
  'pending',
  'waiting_documents',
  'gateway_pending',
  'resubmission_requested'
];

export const PRODUCT_ERROR_STATUSES = ['pending', 'draft', 'waiting'];

export const RECAPTCHA_VALIDATION_ERROR = 'Recaptcha validation failed.';

export const RECAPTCHA_ERROR_MESSAGE =
  'Detectamos um problema com sua solicitação. Por favor, tente novamente usando um dispositivo ou navegador diferente.';
